import React, { Component, createRef } from 'react'
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import { addFlashMessageOfType } from 'redux-flash-messages'
import { withTranslation } from 'react-i18next'

import employeeService from '../../../services/Employee.service'

import BrokerDialog from './BrokerDialog'
import BrokerSatisfaction from './BrokerSatisfaction'

import { BrokerDialogType } from './common'

import { Row, Col, View, Container, Spacer } from '@amzn/stencil-react-components/layout'
import { Card } from '@amzn/stencil-react-components/card'
import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner'
import { Expander } from '@amzn/stencil-react-components/expander'
import { Button, ButtonVariant } from '@amzn/stencil-react-components/button'
import { H2, Text } from '@amzn/stencil-react-components/text'
import { Link } from '@amzn/stencil-react-components/link'

import { actions as employeeActions } from '../../../actions/employee'
import { actions as maintenanceActions } from '../../../actions/maintenance'
import { setLocationOfPriorFocus } from '../common/common'

import { UserRoles } from '../../../constants'

const CARD_WIDTH_MAX = 425;
const CARD_PADDING_TOTAL = 32;
const S600_SPACING = 48;

class BrokerCards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBrokerDialogVisible: false,
      broker: null,
      dialogType: null,
      brokerCardIndex: null,
      loading: false
    };

    this.cardButton = new Array(props.brokerInfo.length).fill(createRef());
  }

  setBrokerDialogVisible = (value, broker, dialogType, index) => {
    this.setState({
      isBrokerDialogVisible: value,
      broker: broker,
      dialogType: dialogType,
      brokerCardIndex: index
    });
  }

  setLoadingState = (value) => {
    this.setState({
      loading: value
    });
  }

  selectedBrokerHandler = (broker, shouldGoToBroker) => {
    const priorFocus = setLocationOfPriorFocus(this.cardButton[this.state.brokerCardIndex]);
    this.setLoadingState(true);

    this.props.actions.employee.changeBroker(broker.code).then(() => {
      this.setLoadingState(false);
      this.setBrokerDialogVisible(false);

      addFlashMessageOfType("SUCCESS", false, this.props.t('AvailableBrokers.SuccessSelectingBroker'), null, priorFocus);

      var brokerUrl = employeeService.getBrokerUrl(broker, this.props.employee);
      if (brokerUrl != '#' && shouldGoToBroker) {
        window.open(brokerUrl, '_blank');
      }
    }).catch(() => {
      this.setLoadingState(false);
      this.setBrokerDialogVisible(false);
      addFlashMessageOfType("ERROR", false, this.props.t('AvailableBrokers.FailedSelectingBroker'), null, priorFocus);
    })
  }

  cancelBrokerHandler = (brokerCode) => {
    const priorFocus = setLocationOfPriorFocus(this.cardButton[this.state.brokerCardIndex]);
    this.setLoadingState(true);

    this.props.actions.employee.changeBroker(brokerCode, true).then(() => {
      this.setLoadingState(false);
      this.setBrokerDialogVisible(false);
      addFlashMessageOfType("SUCCESS", false, this.props.t('AvailableBrokers.SuccessCancelBroker'), null, priorFocus);

    }).catch(() => {
      this.setLoadingState(false);
      this.setBrokerDialogVisible(false);
      addFlashMessageOfType("ERROR", false, this.props.t('AvailableBrokers.FailedCancelingBroker'), null, priorFocus);

    })
  }

  getBrokerVariables = (broker, employee) => {
    return {
      isCurrentBroker: employee.broker && employee.broker.code === broker.code,
      isPendingBroker: employee.pending_broker && employee.pending_broker.code === broker.code,
      isEmployeeDefaultBroker: employee.broker_change_status_cd === "D",
      brokerDisabled: employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_DISABLE),
      brokerChoiceAll: employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_ALL),
      brokerChoiceNone: employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_NONE),
    };
  }

  createCardHeaderLogic = (t, broker, employee) => {
    var {
      isCurrentBroker,
      isEmployeeDefaultBroker,
      brokerDisabled,
      brokerChoiceAll,
      brokerChoiceNone
    } = this.getBrokerVariables(broker, employee);
    var unselectedBroker = !brokerChoiceNone && (!isCurrentBroker || isCurrentBroker && isEmployeeDefaultBroker);
    var hasDefaultedBroker = isCurrentBroker && brokerChoiceAll && isEmployeeDefaultBroker;
    var showINumber = employee.fidelity_activated_in && (employee.broker_inumber && employee.broker_inumber !== '') && employee.W8W9_certification && (employee.broker && employee.broker.code === "FIDELITY");
    var shouldNotShowHeader = (!unselectedBroker || unselectedBroker && !brokerDisabled) && !hasDefaultedBroker && !(isCurrentBroker && showINumber);


    if (shouldNotShowHeader) {
      return null;
    }

    return (
      <Col gridGap="S200">
        {unselectedBroker && brokerDisabled &&
          <MessageBanner type={ MessageBannerType.Informational }>
            {t('AvailableBrokers.BrokerDisabledMessage')}
          </MessageBanner>
        }

        {hasDefaultedBroker &&
          <MessageBanner type={ MessageBannerType.Informational }>
            {t('AvailableBrokers.DefaultedBrokerTitle')}
          </MessageBanner>
        }

        {showINumber && isCurrentBroker &&
          <Expander titleText={t('AvailableBrokers.INumberLabel')}>
            <Col>
              <Text>{employee.broker_inumber}</Text>
              <Text>{t('AvailableBrokers.INumberMessage')}</Text>
            </Col>
          </Expander>
        }
      </Col>
    );
  }

  createCardFooterButtonLogic = (t, broker, employee, index) => {
    var {
      isCurrentBroker,
      isPendingBroker,
      isEmployeeDefaultBroker,
      brokerDisabled,
      brokerChoiceAll,
      brokerChoiceNone
    } = this.getBrokerVariables(broker, employee);
    var unselectedNotPendingBroker = !brokerChoiceNone && (!isCurrentBroker || isCurrentBroker && isEmployeeDefaultBroker) && !isPendingBroker;
    var hasBrokerNotDefaulted = isCurrentBroker && !isEmployeeDefaultBroker
    var unselectedPendingBroker = (!isCurrentBroker || isCurrentBroker && brokerChoiceAll && isEmployeeDefaultBroker) && isPendingBroker;

    if (hasBrokerNotDefaulted) {
      return (
        <Button ref={this.cardButton[index]} disabled={true}>
          {t('AvailableBrokers.CurrentBrokerLabel')}
        </Button>
      );
    } else if (unselectedNotPendingBroker) {
      return (
        <Button
          ref={this.cardButton[index]}
          disabled={brokerDisabled}
          variant={ButtonVariant.Primary}
          dataTestId={'btn-unselectedNotPendingBroker'}
          onClick={() => this.setBrokerDialogVisible(true, broker, BrokerDialogType.Select, index)}
        >
          {t('AvailableBrokers.SelectBrokerButton', {broker_name: broker.name})}
        </Button>
      );
    } else if (unselectedPendingBroker) {
      return (
        <Button
          ref={this.cardButton[index]}
          disabled={brokerDisabled}
          variant={ButtonVariant.Primary}
          dataTestId={'btn-unselectedPendingBroker'}
          onClick={() => this.setBrokerDialogVisible(true, broker, BrokerDialogType.Pending, index)}
        >
          {t('AvailableBrokers.NextStepsLink')}
        </Button>
      );
    }
  }

  createCardFeaturedSection = (brokerComparisons, index) => {
    const featured = brokerComparisons.filter(comparison => !!comparison.featured);
    const unorderedListWithStyle = '<ul style="list-style-type: disc; padding-left: 40px;">';

    return (
      featured.map((feature) =>
        <Col gridGap="S200">
            <H2 tabIndex="-1" id={"BrokerCard_" + index} fontSize="T200" fontWeight="medium">
              { feature.title }
            </H2>
            <Text dangerouslySetInnerHTML={{ __html: feature.content.replace("<ul>", unorderedListWithStyle)}}></Text>
        </Col>
      )
    );
  }

  createBrokerCard = (t, broker, brokerComparisons, employee, index) => {
    return (
      <Card key={"BrokerCard_" + broker.code}>
        <Col gridGap="S400" maxWidth={CARD_WIDTH_MAX}>
          { this.createCardHeaderLogic(t, broker, employee) }
          <View alignSelf="center">
            <img
              src={`/image/broker-logo-${broker.code}.svg`}
              width="255px"
              height="75px"
              alt={`${broker.name} Broker Logo`}
            />
          </View>
          { this.createCardFeaturedSection(brokerComparisons, index) }
          <Link href={broker.url2 ? broker.url2 : ''} target="_blank" textAlign="center">
            {t('AvailableBrokers.GotoBrokerSiteButton', {broker_name: broker.name})}
          </Link>
          <Spacer flex={1}/>
          <View alignSelf="center">
            {this.createCardFooterButtonLogic(t, broker, employee, index)}
          </View>
        </Col>
      </Card>
    );
  }

  render() {
    const { t, brokerInfo, employee } = this.props;
    var viewOnly = employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_VIEW) ? true : false;
    var isPendingBroker = employee.pending_broker;
    const pendingBrokerBannerMaxWidth = S600_SPACING + 2 * (CARD_WIDTH_MAX + CARD_PADDING_TOTAL);

    return (
      <>
      {isPendingBroker &&
        <Container maxWidth={pendingBrokerBannerMaxWidth} alignSelf="center">
          <MessageBanner type={ MessageBannerType.Warning }>
            {t('AvailableBrokers.PendingElectionTitle')}
          </MessageBanner>
        </Container>
      }
      <Col gridGap="S300" alignItems="center">
        <Row gridGap="S600" flexWrap="wrap" justifyContent="center">
          {brokerInfo.map(({broker, broker_comparisons}, index) => (
            this.createBrokerCard(t, broker, broker_comparisons, employee, index)
          ))}
          <BrokerDialog
            visible={this.state.isBrokerDialogVisible}
            onCloseDialog={() => this.setBrokerDialogVisible(false)}
            onSelectedBroker={this.selectedBrokerHandler}
            onPendingBroker={this.cancelBrokerHandler}
            broker={this.state.broker}
            viewOnly={viewOnly}
            dialogType={this.state.dialogType}
            loading={this.state.loading}
          />
        </Row>
        <BrokerSatisfaction/>
      </Col>
      </>
    );
  }
}

const mapState = state => ({
  brokerInfo: employeeService.reorderBrokerInfo(state.static_content.broker_info, state.employee),
  employee: state.employee
});

const mapDispatchToProps = dispatch => ({
    actions: {
      employee: bindActionCreators(employeeActions, dispatch),
      maintenance: bindActionCreators(maintenanceActions, dispatch),
    }
})

export default connect(mapState, mapDispatchToProps)(withTranslation('translationsV2')(BrokerCards))
